import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListPekerjaan } from "@/services/getData"

export default function MasterPekerjaanPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listPekerjaan"],
    queryFn: getListPekerjaan,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
